import { render, staticRenderFns } from "./VasSubscriptionForm.vue?vue&type=template&id=53247ef6"
import script from "./VasSubscriptionForm.vue?vue&type=script&lang=js"
export * from "./VasSubscriptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports